import { useQuery } from '@tanstack/react-query'
import { orpc } from '@/lib/orpc'
import { useSession } from '@/lib/auth-client'

/**
 * Staff session for `/admin` (moderator or admin).
 * Disabled when signed out; no retry so FORBIDDEN fails fast for the gate.
 */
export function useAdminMe() {
  const { data: session } = useSession()
  return useQuery({
    ...orpc.admin.me.queryOptions(),
    enabled: Boolean(session),
    retry: false,
    staleTime: 15_000,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  })
}
